import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const About = () => {

  const [menuOpen, setMenuOpen] = useState(false);

  const stats = [
    { count: '20', suffix: '+', label: 'Years ERP Experience' },
    { count: '50', suffix: '+', label: 'Successful Implementations' },
    { count: '10', suffix: '+', label: 'Industries Served' },
    { count: '100', suffix: '%', label: 'Client Focused Delivery' },
  ];

  return (
    <div className="main-wrapper">
      <Navbar transparent />

      <PageTitle title="About Us" />

      {/* ===== ABOUT CONTENT ===== */}
      <section className="md pt-2">
        <div className="container lg-container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-5 mb-lg-0 text-center">
              <img src="/img/content/content-10.svg" alt="Source-ERP - Microsoft Dynamics Partner" className="img-fluid" />
            </div>
            <div className="col-lg-6">
              <span className="text-primary font-weight-600 d-block mb-2">Who We Are</span>
              <h2 className="font-weight-700 mb-4">Your Trusted Microsoft Dynamics 365 Partner</h2>
              <p className="mb-4 display-28">
                Source-ERP is a specialized Microsoft Dynamics 365 consulting
                company focused on delivering enterprise-grade ERP solutions.
                We help organizations streamline finance, supply chain,
                manufacturing, and operations through proven implementation
                methodologies and industry best practices.                
              </p>
              <p className="mb-4">
                Our team combines deep functional expertise with technical excellence to deliver scalable, efficient, and future-ready systems. 
                From implementation to advanced analytics and mobile applications, we enable organizations to operate smarter and faster.
              </p>

              <h4 className="font-weight-600 mb-3 mt-5">What We Deliver</h4>
              <ul className="list-style7 mb-4">
                <li><i className="fas fa-check"></i>Certified Microsoft Dynamics 365 implementations &amp; customizations</li>
                <li><i className="fas fa-check"></i>End-to-end CRM &amp; ERP solutions (Finance, Supply Chain, Sales, Business Central)</li>
                <li><i className="fas fa-check"></i>Seamless integrations with Power Platform, Azure, and third-party systems</li>
                <li><i className="fas fa-check"></i>Ongoing support, upgrades, training, and optimization services</li>
              </ul>

              <Link to="/contact" className="butn style-one fill mt-3">Get In Touch</Link>
            </div>
          </div>
        </div>
      </section>

      {/* ===== LEADERSHIP EXPERIENCE ===== */}
<section className="md bg-light-grey">
  <div className="container">
    <div className="row align-items-center">
      
      <div className="col-lg-6 mb-4 mb-lg-0">
        <span className="text-primary font-weight-600 d-block mb-2">
          Leadership Experience
        </span>
        <h2 className="font-weight-700 mb-4">
          Driven by ERP Industry Veterans
        </h2>

        <p className="mb-3">
          Source-ERP is led by industry veterans with over two decades of
          hands-on experience in ERP implementation, consulting, and enterprise
          digital transformation.
        </p>

        <p className="mb-3">
          Our leadership team has successfully delivered complex ERP projects
          across multiple industries and geographies, with deep expertise in
          SAP, Oracle, Microsoft Dynamics AX, and Dynamics 365 Finance &
          Operations.
        </p>

        <p className="mb-0">
          From business process analysis to deployment, customization,
          integration, and long-term support — our experts have executed full
          lifecycle ERP implementations for global clients.
        </p>
      </div>

      <div className="col-lg-6 text-center">
        <img
          src="/img/content/content-01.png"
          alt="ERP Leadership Experience"
          className="img-fluid"
        />
      </div>

    </div>
  </div>
</section>

      {/* ===== STATS ===== */}
      <section className="bg-primary-solid counter-box02">
        <span className="right-shape d-none d-xl-block">
          <img src="/img/content/object-01.png" alt="" />
        </span>
        <span className="left-shape"></span>
        <div className="container position-relative" style={{ zIndex: 99 }}>
          <div className="w-95 w-sm-90 w-lg-50 text-center mx-auto mb-5">
            <span className="d-block mb-2 text-white font-weight-600">We provide best</span>
            <h2 className="text-white">The bright and easiest help to grow your business</h2>
          </div>

          <div className="row mt-n5">
            {stats.map((stat, idx) => (
              <div className="col-6 col-md-3 mt-5" key={idx}>
                <div className="text-center">
                  <h4 className="text-white h1">
                    <span className="countup">{stat.count}</span>{stat.suffix}
                  </h4>
                  <p className="mb-0 text-white">{stat.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
